import { find } from 'lodash';

import { BET_STEPS } from 'app-constants';

export default function findBetStep(bet: number): number {
    return find(BET_STEPS, (step, breakpoint) => bet <= +breakpoint)!;
}
